import { ApiErrorHandler } from "components/errorHandler/index";
import setupAxios from "config/axios";
export const axios = setupAxios();

const makeRequest = async (url, method, queryParams = null, payload = null) => {
    try {
        const config = {
            url,
            method
        };

        if (queryParams) {
            config.params = queryParams;
        }

        if (payload) {
            config.data = payload;
        }
        const response = await axios.request(config);
        return response.data;
    } catch (error) {
        throw ApiErrorHandler(error);
    }
};

export const makeRequestWithHeaders = async (url, method, headers, queryParams = null, payload = null) => {
    try {
        const axios = setupAxios(headers);
        const config = {
            url,
            method
        };

        if (queryParams) {
            config.params = queryParams;
        }

        if (payload) {
            config.data = payload;
        }
        const response = await axios.request(config);
        return response.data;
    } catch (error) {
        throw ApiErrorHandler(error);
    }
};

// export const makeRequestWithHeadersForXhr = async (url, method, headers, queryParams = null, payload = null) => {
//     try {
//         const axios = setupAxiosForXHRRequests(headers);
//         const config = {
//             url,
//             method
//         };

//         if (queryParams) {
//             config.params = queryParams;
//         }

//         if (payload) {
//             config.data = payload;
//         }
//         const response = await axios.request(config);
//         return response.data;
//     } catch (error) {
//         throw ApiErrorHandler(error);
//     }
// };

export default makeRequest